export const IconCopy = () => {
  return (
    <svg
      width="35"
      height="35"
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.791 19.5423V23.9173C24.791 29.7506 22.4577 32.084 16.6243 32.084H11.0827C5.24935 32.084 2.91602 29.7506 2.91602 23.9173V18.3757C2.91602 12.5423 5.24935 10.209 11.0827 10.209H15.4577"
        stroke="#053462"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.7923 19.5423H20.1257C16.6257 19.5423 15.459 18.3757 15.459 14.8757V10.209L24.7923 19.5423Z"
        stroke="#053462"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.916 2.91602H22.7493"
        stroke="#053462"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.209 7.29102C10.209 4.87018 12.1632 2.91602 14.584 2.91602H18.4048"
        stroke="#053462"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.0842 11.666V20.6931C32.0842 22.9535 30.2467 24.791 27.9863 24.791"
        stroke="#053462"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.084 11.666H27.709C24.4277 11.666 23.334 10.5723 23.334 7.29102V2.91602L32.084 11.666Z"
        stroke="#053462"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
